import React from 'react';

export const Facebook = ({}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <path
      fill-rule="evenodd"
      d="M33 18.088C33 9.755 26.284 3 18 3 9.716 3 3 9.755 3 18.088c0 7.531 5.485 13.774 12.656 14.906V22.45h-3.808v-4.362h3.808v-3.324c0-3.781 2.24-5.87 5.666-5.87 1.641 0 3.358.295 3.358.295v3.713h-1.892c-1.863 0-2.444 1.163-2.444 2.356v2.83h4.16l-.665 4.362h-3.495v10.544C27.514 31.862 33 25.619 33 18.088"
    />
  </svg>
);
